// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__28-jN","paramInput":"JobSimulator_paramInput__1BUzl","input":"JobSimulator_input__5T3LY"};